module.exports = __webpack_public_path__ + "static/EnmTX_BosWerner_L_A_cl-eeb7109d8e538e815e7484d5a477495d.gif";